<template>
    <div
        :class="{
            home: true,
            'is-from-crm-family': isFromCrmFamily(),
        }"
    >
        <nav-page></nav-page>
        <router-view />
        <nav-footer></nav-footer>
        <side-nav></side-nav>
    </div>
</template>

<script>
import NavPage from '../components/NavPage.vue'
import NavFooter from '../components/NavFooter.vue'
import SideNav from '@/components/SideNav.vue'
import { isFromCrmFamily } from '@/utils/formAppInfo.js'

// HOME 页面默认路由
export default {
    components: {
        NavPage,
        NavFooter,
        SideNav,
    },
    methods: {
        isFromCrmFamily,
    },
}
</script>

<style lang="less" scoped>
.home.is-from-crm-family {
    .nav-page,
    .nav-footer,
    .side-nav {
        display: none;
    }
}
</style>
